import { useEffect, useState } from "react";

const MarketScope = ({ report }) => {
  const [dataregions, setdataRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [SegmentsWithSubSegments, setSegmentsWithSubSegments] = useState([]);
  const [uniqueNamesArray, setUniqueNamesArray] = useState([]);
  useEffect(() => {
    if (report?.regions) {
      setdataRegions(report?.regions);
      // console.log("regiondata", dataregions);
      const countriesList = report?.regions?.map((region) => region.country);

      const regionsList = [
        ...new Set(report?.regions?.map((region) => region.region)),
      ];
      setRegions(regionsList);
      setCountries(countriesList);

      // Object to group sub-segments by their parent segment
      const segmentsWithSubSegments = {};

      // Iterate through report.segments to extract segments and sub-segments
      // report?.segments?.forEach((segment) => {
      //   segment?.segments?.forEach((subSegment) => {
      //     const segmentName = subSegment.name;

      //     if (!segmentsWithSubSegments[segmentName]) {
      //       segmentsWithSubSegments[segmentName] = new Set();
      //     }

      //     // Add unique sub-segment names to the Set
      //     subSegment.subSegments.forEach((sub) => {
      //       segmentsWithSubSegments[segmentName].add(sub.name);
      //     });
      //   });
      // });

      // Convert Sets to arrays for rendering
      const segmentsWithSubSegmentsArray = {};
      for (const [key, value] of Object.entries(segmentsWithSubSegments)) {
        segmentsWithSubSegmentsArray[key] = Array.from(value);
      }

      // Set the cleaned object in state
      setSegmentsWithSubSegments(segmentsWithSubSegmentsArray);

      // Create a unique names array
      const uniqueNamesArray = Object.keys(segmentsWithSubSegmentsArray);
      setUniqueNamesArray(uniqueNamesArray);
      // console.log("dgd", uniqueNamesArray, SegmentsWithSubSegments);
    }
  }, [report]);
  return (
    <>
      <div className="bg-white rounded shadow p-6 mb-6 mx-auto overflow-auto scroll-smooth">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          {report?.reportTitle} Market Scope
        </h2>
        <div
          style={{
            display: "flex",
            gap: "15px",
            overflowX: "auto",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            paddingBottom: "10px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="max-h-[400px]"
        >
          {Object?.entries(SegmentsWithSubSegments)?.map(
            ([segment, subSegments]) => (
              <div key={segment}>
                <h3 className="text-center font-bold text-pink-600 mb-2">
                  {segment}
                </h3>
                <ul className="space-y-2">
                  {subSegments?.map((subSegment, index) => (
                    <li
                      key={index}
                      className="bg-gray-200 p-2 rounded text-center text-black"
                    >
                      <button
                        className="text-black hover:text-blue-800"
                        // onClick={() => handleSubSegmentClick(subSegment)}
                      >
                        {subSegment}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )
          )}
          {report?.allSegments?.length > 0
            ? report.allSegments.map((item, index) => (
                <div style={{ minWidth: "200px" }} key={index}>
                  <h3 className="text-center font-bold text-pink-600 mb-2">
                    {item.segment}
                  </h3>
                  <ul className="space-y-2">
                    {item.subsegments.map((sub, subIndex) => (
                      <li
                        key={subIndex}
                        className="bg-gray-200 p-2 rounded text-center text-black"
                      >
                        <button
                          // onClick={() =>
                          //   handleSegmentClick(item.segment, sub)
                          // }
                          className="text-black hover:text-blue-800"
                        >
                          {sub}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            : null}
          <div>
            <h3 className="text-center font-bold text-pink-600 mb-2">Region</h3>
            <ul className="space-y-2">
              {(regions.length > 0
                ? regions
                : [
                    "North America",
                    "Europe",
                    "Asia Pacific",
                    "Latin America",
                    "Middle East & North Africa",
                  ]
              ).map((region, index) => (
                <li
                  key={index}
                  className="bg-gray-200 p-2 rounded text-center text-black"
                >
                  <button
                    // onClick={() => handleRegionClick(region)}
                    className="text-black hover:text-blue-800"
                  >
                    {region}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-center font-bold text-pink-600 mb-2">
              Countries
            </h3>
            <ul className="space-y-2">
              {(countries.length > 0
                ? countries
                : [
                    "U.S.",
                    "Canada",
                    "UK",
                    "Germany",
                    "France",
                    "Spain",
                    "Italy",
                    "Rest of Europe",
                    "China",
                    "India",
                    "Japan",
                    "Australia",
                    "South Korea",
                    "Rest of Asia Pacific",
                    "Brazil",
                    "Mexico",
                    "Rest of Latin America",
                    "Saudi Arabia",
                    "UAE",
                    "Rest of Middle East & North Africa",
                  ]
              ).map((country, index) => (
                <li
                  key={index}
                  className="bg-gray-200 p-2 rounded text-center text-black"
                >
                  <button
                    // onClick={() => handleCountryClick(country)}
                    className="text-black hover:text-blue-800"
                  >
                    {country}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketScope;
